/**
 * 이용약관·개인정보처리방침 정적 페이지 공용 스타일.
 * docs/input/indipia_이용약관및운영정책 방식 기획(화면구성예시).html의 문서 뷰(.doc-head/.card/.toc/.chapter/.sec 등) CSS를
 * `.legal-doc` 스코프 아래로 그대로 포팅.
 */
export const legalDocStyles = `
.legal-doc{
  --ink:var(--shell-on-surface); --sub:var(--shell-on-surface-2); --line:var(--shell-border); --bg:var(--shell-bg); --card:var(--shell-surface);
  --primary:var(--shell-point); --primary-soft:var(--shell-point-subtle);
  font-size:15px;line-height:1.75;color:var(--ink);background:var(--bg);
}
.legal-doc a{color:var(--primary);text-decoration:underline;text-underline-offset:3px}
.legal-doc a.plink{color:var(--primary);text-decoration:underline;text-underline-offset:3px}
.legal-doc .page{max-width:800px;margin:0 auto;padding:36px 20px 80px}
.legal-doc .doc-head h1{font-size:26px;font-weight:800;letter-spacing:-.02em}
.legal-doc .doc-head .meta{margin-top:8px;font-size:13px;color:var(--sub)}
.legal-doc .doc-head .meta b{color:var(--ink);font-weight:600}
.legal-doc .card{background:var(--card);border:1px solid var(--line);border-radius:12px;padding:24px;margin-top:20px}
.legal-doc .toc h2{font-size:14px;font-weight:700;margin-bottom:10px;color:var(--sub)}
.legal-doc .toc ol{list-style:none;columns:2;column-gap:24px;font-size:13.5px}
.legal-doc .toc li{margin-bottom:6px;break-inside:avoid}
.legal-doc .toc a{color:var(--ink);text-decoration:none}
.legal-doc .toc a:hover{color:var(--primary);text-decoration:underline;text-underline-offset:3px}
.legal-doc .chapter{margin-top:40px;scroll-margin-top:24px}
.legal-doc .chapter>h2{font-size:14px;font-weight:700;color:var(--primary);letter-spacing:.02em;padding-bottom:8px;border-bottom:2px solid var(--primary);display:inline-block}
.legal-doc article{margin-top:26px;scroll-margin-top:24px}
.legal-doc article h3{font-size:16.5px;font-weight:700;margin-bottom:8px;letter-spacing:-.01em}
.legal-doc article p{margin-bottom:8px}
.legal-doc article ol.hang{list-style:none;margin-bottom:8px}
.legal-doc article ol.hang>li{padding-left:1.6em;text-indent:-1.6em;margin-bottom:6px}
.legal-doc article ol.hang a.plink{text-indent:0;display:inline}
.legal-doc article ol.num{margin:4px 0 8px 1.4em}
.legal-doc article ol.num>li{margin-bottom:5px}
.legal-doc section.policy,.legal-doc section.sec{margin-top:40px;scroll-margin-top:24px}
.legal-doc section.policy>h2,.legal-doc section.sec>h2{font-size:18px;font-weight:800;letter-spacing:-.01em;padding-bottom:8px;border-bottom:2px solid var(--primary)}
.legal-doc section.policy>.link-ref{font-size:var(--type-caption-size);color:var(--sub);margin-top:6px}
.legal-doc section.policy>.link-ref a{color:var(--sub)}
.legal-doc section.policy h3{font-size:15px;font-weight:700;margin:18px 0 6px}
.legal-doc section.policy p,.legal-doc section.sec p{margin-bottom:8px}
.legal-doc section.sec p{margin-top:10px}
.legal-doc section.policy ul{list-style:none;margin-bottom:8px}
.legal-doc section.policy ul>li{padding-left:1.1em;text-indent:-1.1em;margin-bottom:5px}
.legal-doc section.policy ul>li::before{content:'\\2013  '}
.legal-doc section.sec ol.hang{list-style:none;margin-top:10px}
.legal-doc section.sec ol.hang>li{padding-left:1.6em;text-indent:-1.6em;margin-bottom:6px}
.legal-doc .note{font-size:13px;color:var(--sub);background:var(--gray-50);border-radius:8px;padding:12px 14px;margin:10px 0}
.legal-doc table{width:100%;border-collapse:collapse;margin:12px 0;font-size:13.5px}
.legal-doc th,.legal-doc td{border:1px solid var(--line);padding:9px 12px;text-align:left;vertical-align:top}
.legal-doc th{background:var(--gray-50);font-weight:600;white-space:nowrap}
.legal-doc td.c{text-align:center;white-space:nowrap}
.legal-doc .intro{margin-top:20px}
.legal-doc .topbar{position:sticky;top:0;z-index:var(--z-sticky);background:var(--card);border-bottom:1px solid var(--line);padding:14px 20px;display:flex;align-items:center;gap:12px}
.legal-doc .topbar button{background:none;border:none;cursor:pointer;font-size:14px;color:var(--sub);font-family:inherit;display:flex;align-items:center;gap:6px}
.legal-doc .topbar button:hover{color:var(--ink)}
@media (max-width:600px){
  .legal-doc .toc ol{columns:1}
  .legal-doc{font-size:14.5px}
  .legal-doc .doc-head h1{font-size:22px}
  .legal-doc th,.legal-doc td{padding:7px 8px;font-size:var(--type-caption-size)}
  .legal-doc td.c{white-space:normal}
  .legal-doc .page{padding:24px 14px 60px}
}
`;
